import request from '@/utils/request'

//获取课程实体
export function getCourseBody(data) {
    console.log("999")
    console.log(data)
    return request({
      url: '/Course/getCourseBody.do',
      method: 'post',
      data:data
    })
}



//获取课程列表
export function getTopicList(data) {
  return request({
    url: '/Course/getTopicList.do',
    method: 'post',
    data
  })
}




//获取章节实体
export function getGroupTopicBody(data) {
  return request({
    url: '/Course/getGroupTopicBody.do',
    method: 'post',
    data
  })
}




//获取章节资源
export function getTopicResourceList(data) {
  return request({
    url: '/Course/getTopicResourceList.do',
    method: 'post',
    data
  })
}



//获取章节资源实体
export function getTopicResourceBody(data) {
  return request({
    url: '/Course/getTopicResourceBody.do',
    method: 'post',
    data:data
  })
}


//获取课程信息
export function getCourseInfo(data) {
  return request({
    url: '/Course/getCourseInfo.do',
    method: 'get',
    params:data
  })
}

//获取课程信息
export function getCourseInfoNew(data) {
  return request({
    url: '/Course/getCourseInfoNew.do',
    method: 'get',
    params:data
  })
}

//获取指定标签的课程列表
export function getCourseListWithTag(data) {
  return request({
    url: '/Course/getCourseListWithTag.do',
    method: 'get',
    params:data
  })
}

//上传图片
export function uploadImage(data) {
  return request({
    url: '/Course/uploadImage.do',
    method: 'post',
    data:data
  })
}

//获取课程资源ID
export function getResourceIdAPI(data) {
  return request({
    url: '/Course/getResourceId.do',
    method: 'get',
    params:data
  })
}

//获取课程内容
export function getTextResourceContentAPI(data) {
  return request({
    url: '/Course/getTextResourceContent.do',
    method: 'get',
    params:data
  })
}
